import React from 'react';
import {useLocation} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import {useAuthorizationState} from '../../contexts/Authorization';
import LogIn04Svg from '../../assets/icons0/log-in-04.svg';
import {queryParameters} from '../../qs';
import searchUnFilter from '../../searchUnFilter';
import Button from '../button/button';
import Avatar120120Png from '../../assets/avatar-120-120@3x.png';

const RAZZLE_APP_ACCOUNTS = process.env.RAZZLE_APP_ACCOUNTS;
const User = ({userMenuButtonRef, toggleUserMenu}) => {
    const authorized = useAuthorizationState();
    const location = useLocation();
    const qps = queryParameters(location);
    const signIn = (e) => {
        e.preventDefault();
        setTimeout(() => {
            window.location.href = RAZZLE_APP_ACCOUNTS + '/endpoint?cache=0&new=true&cache=0&continue='
                + encodeURIComponent(location.pathname + searchUnFilter(document.location.search))
                + (qps.length ? '&' + qps.join('&') : '');
        }, 500);
    };
    return (
        <div ref={userMenuButtonRef} className='hide-small padding-left-0dot75rem'>
            {authorized ?
                <img className='display-block height-2dot5rem width-2dot5rem cursor-pointer' src={Avatar120120Png} alt='' onClick={toggleUserMenu}/>
                :
                <div className='display-flex align-items-center'>
                    <Button color='secondary-gray' clickHandler={signIn} iconPosition='left' size='md'>
                        <LogIn04Svg className='display-block height-1dot25rem width-1dot25rem color-gray-700'/>
                        <FormattedMessage defaultMessage='Sign in'/>
                    </Button>
                </div>
            }
        </div>
    );
};

export default React.memo(User);